import API from "../../../../../global/api";


export const requestAddUom = () => {
    return {
        type: "REQUEST_ADD_UOM",
    };
};
export const successAddUom = (data) => {
    return {
        type: "SUCCESS_ADD_UOM",
        payload: data,
    };
};
export const errorAddUom = () => {
    return {
        type: "ERROR_ADD_UOM",
    };
};
export const addUom = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddUom());
        API.post(`/uom`, data).then((res) => {
            dispatch(successAddUom(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddUom());
            handleDangerVisible(error.response.data.message);
        })
    };
};


export const requestUOM = () => {
    return {
        type: "REQUEST_UOM",
    };
};
export const successUOM = (data) => {
    return {
        type: "SUCCESS_UOM",
        payload: data,
    };
};
export const errorUOM = () => {
    return {
        type: "ERROR_UOM",
    };
};
export const GetUOMApi = () => {
    return (dispatch) => {
        dispatch(requestUOM());
        API.get(`/uom`).then((res) => {
            let getData = res.data;
            dispatch(successUOM(getData));
        }).catch((error) => {
            dispatch(errorUOM());
        })
    };
};